/**
 * Pure string-cleaning utilities for AI narrative text.
 * Extracted from requests.$id.tsx and look-of-day-section.tsx
 * so they can be unit tested independently of React.
 */

export function cardSummaryFull(
  text: string,
  maxChars = 62
): { summary: string; full: string; truncated: boolean } {
  const full = text
    .replace(/\*+([^*]+)\*+/g, "$1")
    .replace(/[*_`]/g, "")
    .replace(/\n?^-{2,}$/gm, "")
    .trim();
  const sentenceMatch = full.match(/^[^.!?]+[.!?]/);
  const firstSent = sentenceMatch
    ? sentenceMatch[0].trim()
    : full.slice(0, maxChars).trim();
  const summary =
    firstSent.length > maxChars
      ? firstSent.slice(0, maxChars).trimEnd() + "…"
      : firstSent;
  return {
    summary,
    full,
    truncated: full.trim() !== summary.replace(/…$/, "").trim(),
  };
}

export function cleanEditorialLine(suggestedLook: string): string | null {
  if (!suggestedLook) return null;
  const cleaned = suggestedLook
    .replace(/^.*?---+\s*/s, "")
    .replace(/\*+([^*]+)\*+/g, "$1")
    .replace(/[*_`]/g, "")
    .replace(/\n?^-{2,}$/gm, "")
    .trim();
  const match = cleaned.match(/^[^.!?]+[.!?]/);
  return match ? match[0].trim() : cleaned.slice(0, 120).trim();
}
